import * as React from 'react';
import InvestorTypesComponent, { InvestorTypesComponentProps } from './InvestorTypes.component';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import InvestorType from 'src/entities/InvestorType';
import { getInvestorType, GetInvestorTypeAction } from 'src/actions/investor-type/get/GetInvestorType.actions';
import * as getInvestorTypeTypes from 'src/actions/investor-type/get/Types';
import {
  updateInvestorType,
  UpdateInvestorTypeAction
} from 'src/actions/investor-type/update/UpdateInvestorType.actions';
import * as updateInvestorTypeTypes from 'src/actions/investor-type/update/Types';
import User from 'src/entities/User';
import { getUser, GetUserAction } from 'src/actions/user/get/GetUser.actions';
import * as getUserTypes from 'src/actions/user/get/Types';
import {
  changeInvestorType,
  ChangeInvestorTypeAction
} from 'src/actions/investor-type/change-data/ChangeInvestorType.actions';
import LoadingContainer from 'src/modules/commons/loading/Loading.container';
import { OpenModal, openModal } from 'src/actions/modal';
import ChangeActiveProfileContainer
  from 'src/modules/modals/investment-funnel/change-profile/ChangeActiveProfile.container';
import Person from 'src/entities/Person';
import {
  checkRequiredProfile,
  CheckRequiredProfileAction,
  checkRequiredProfileClear
} from 'src/actions/user/requiredProfile/CheckRequiredProfile.actions';
import * as checkRequiredProfileTypes from 'src/actions/user/requiredProfile/Types';
import { history } from 'src/store';

interface State {
  showIncompleteProfileWarning: boolean;
  success: boolean;
}

interface StateProps {
  user?: User;
  loggedUserData: number | null;
  activeProfile?: Person;
  investorType?: InvestorType;
  formData?: InvestorType;
  error: boolean;
  errorMessage: {};
}

interface DispatchProps {
  checkRequiredProfileClear: () => CheckRequiredProfileAction;

  getUser(userId: number): Promise<GetUserAction>;

  getInvestorType(personId: number, personType: string): Promise<GetInvestorTypeAction>;

  updateInvestorType(personId: number, personType: string, investorType: InvestorType):
    Promise<UpdateInvestorTypeAction>;

  changeInvestorType(investorType: InvestorType):
    ChangeInvestorTypeAction;

  openModal(component: JSX.Element): void;

  checkRequiredProfile(personId: number, personType: string): Promise<CheckRequiredProfileAction>;
}

interface Props extends StateProps, DispatchProps {

}

class InvestorTypesContainer extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.props.checkRequiredProfileClear();
    this.state = {
      showIncompleteProfileWarning: false,
      success: false,
    };
  }

  public componentWillMount(): void {
    const userId = this.props.loggedUserData!;
    this.props.getUser(userId).then((response) => {
      if (response.type === getUserTypes.GET_USER_SUCCESS) {
        this.props.getInvestorType(this.props.activeProfile!.id, this.props.activeProfile!.personType).then(
          (investorTypeResponse) => {
            if (investorTypeResponse.type === getInvestorTypeTypes.GET_INVESTOR_TYPE_SUCCESS) {
              this.props.changeInvestorType(
                new InvestorType(this.props.investorType!)
              );
            }
          });
      }
    });
  }

  public componentWillReceiveProps(nextProps: StateProps) {
    if ((this.props.activeProfile && nextProps.activeProfile &&
      (nextProps.activeProfile.id !== this.props.activeProfile.id ||
      nextProps.activeProfile.personType !== this.props.activeProfile.personType)) ||
      (!this.props.activeProfile && nextProps.activeProfile)) {
      this.props.getInvestorType(nextProps.activeProfile.id, nextProps.activeProfile.personType).then(
        (response) => {
          if (response.type === getInvestorTypeTypes.GET_INVESTOR_TYPE_SUCCESS) {
            this.props.changeInvestorType(
              new InvestorType(this.props.investorType!)
            );
          }
        });
    }
  }

  public render(): React.ReactNode {
    return (
      this.props.formData ?
        <InvestorTypesComponent {...this.getComponentProps()} /> :
        <LoadingContainer/>
    );
  }

  private handleSubmit(): void {
    this.props.updateInvestorType(
      this.props.activeProfile!.id,
      this.props.activeProfile!.personType,
      this.props.formData!
    ).then((response) => {
      if (response.type === updateInvestorTypeTypes.UPDATE_INVESTOR_TYPE_SUCCESS) {
        this.setState({success: true});
      }
    });
  }

  private checkProfile(): void {
    const personId = this.props.activeProfile!.id;
    const personType = this.props.activeProfile!.personType;
    this.props.checkRequiredProfile(personId, personType).then((response) => {
      if (response.type === checkRequiredProfileTypes.CHECK_REQUIRED_PROFILE_SUCCESS) {
        history.push('/mi-cuenta/tipo-de-inversor/test');
      }
    });
  }

  private changeProfile(): void {
    this.props.openModal(
      <ChangeActiveProfileContainer/>
    );
  }

  private redirectProfile(): void {
    if (this.props.activeProfile!.personType === 'physical') {
      history.push('/mi-cuenta/perfil/fisico/editar');
    } else {
      history.push('/mi-cuenta/perfil/juridico/editar/' + this.props.activeProfile!.id);
    }
  }

  private getComponentProps(): InvestorTypesComponentProps {
    return {
      profileType: this.props.activeProfile!.personType,
      investorType: this.props.formData!,
      handleSubmit: () => this.handleSubmit(),
      checkProfile: () => this.checkProfile(),
      changeProfile: () => this.changeProfile(),
      redirectProfile: () => this.redirectProfile(),
      errorMessage: this.props.errorMessage,
      error: this.props.error,
      success: this.state.success,
      activeProfile: this.props.activeProfile!,
    };
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
  getUser: (userId: number): Promise<GetUserAction> => (
    dispatch(getUser(userId))
  ),
  getInvestorType: (personId: number, personType: string): Promise<GetInvestorTypeAction> => (
    dispatch(getInvestorType(personId, personType))
  ),
  updateInvestorType: (personId: number, personType: string, investorType: InvestorType):
    Promise<UpdateInvestorTypeAction> => (
    dispatch(updateInvestorType(personId, personType, investorType))
  ),
  changeInvestorType: (investorType: InvestorType):
    ChangeInvestorTypeAction => (
    dispatch(changeInvestorType(investorType))
  ),
  openModal: (component: JSX.Element): OpenModal => (
    dispatch(openModal(component))
  ),
  checkRequiredProfile: (personId: number, personType: string): Promise<CheckRequiredProfileAction> => (
    dispatch(checkRequiredProfile(personId, personType))
  ),
  checkRequiredProfileClear: (): CheckRequiredProfileAction => {
    return dispatch(checkRequiredProfileClear());
  }
});

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  user: state.getUser.user,
  loggedUserData: state.authentication.loggedUserData,
  activeProfile: state.getUser.activeProfile,
  investorType: state.getInvestorType.investorType,
  formData: state.changeInvestorType.investorType,
  error: state.checkRequiredProfile.error,
  errorMessage: state.checkRequiredProfile.errorMessage,
});

export default connect(mapStateToProps, mapDispatchToProps)(InvestorTypesContainer);



// WEBPACK FOOTER //
// ./src/modules/my-account/investor-types/InvestorTypes.container.tsx